import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const SK: DeepPartial<AddressBook> = {
    abcSelectorButtons: [
        {
            icon: 'star',
            i18Key: 'addressbook:filter.topContacts',
            matches: 'TOP_CONTACTS',
            alwaysEnabled: true,
        },
        {
            key: '123',
            matches: 'OTHER',
        },
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'CH',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ],
    cacheDuration: {
        contact: 10000,
        template: 10000,
        templates: 10000,
        search: 5000,
    },
};
